import {
  ListItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { IconContext } from "react-icons";
import { MdRestore, MdSettingsInputComponent } from "react-icons/md";
import Swal from "sweetalert2";

export const RestoreDataSettings = () => {
  const handleClickRestoreSettings = () => {
    localStorage.removeItem("idSolicitudPromocion");
    localStorage.removeItem("listFilesPromocion");
    localStorage.removeItem("selectedIndex");
    localStorage.removeItem("openDrawer");
    localStorage.removeItem("certKeyList");
    localStorage.removeItem("currentStepPromocion");
    localStorage.removeItem("idSolicitud");
    localStorage.removeItem("typeTheme");
    localStorage.removeItem("currentStep");
    localStorage.removeItem("listFiles");
    localStorage.removeItem("lastpath");
    Swal.fire({
      title: "Correcto",
      text: "Se ha restablecido la configuración del sistema ",
      icon: "success",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton onClick={handleClickRestoreSettings}>
          <MdRestore />
        </IconButton>
      }
    >
      <ListItemIcon>
        <IconContext.Provider value={{ className: "text-4xl" }}>
          <MdSettingsInputComponent />
        </IconContext.Provider>
      </ListItemIcon>
      <ListItemText
        primary="Restablecer configuraciones del sistema"
        secondary="Puedes restaurar las configuraciones , si presentas algún problema con el sistema."
      />
    </ListItem>
  );
};
